var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedTrash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-trash-outline",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.75,
    height: 18,
    viewBox: "0 0 15.75 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "trash-alt-regular",
    d: "M9.422,14.625h.844a.422.422,0,0,0,.422-.422V6.609a.422.422,0,0,0-.422-.422H9.422A.422.422,0,0,0,9,6.609V14.2A.422.422,0,0,0,9.422,14.625ZM15.187,2.812h-2.9L11.095.819A1.687,1.687,0,0,0,9.647,0H6.1A1.688,1.688,0,0,0,4.656.819L3.46,2.812H.562A.562.562,0,0,0,0,3.375v.563A.563.563,0,0,0,.562,4.5h.562V16.312A1.688,1.688,0,0,0,2.812,18H12.938a1.688,1.688,0,0,0,1.687-1.688V4.5h.563a.562.562,0,0,0,.563-.562V3.375A.562.562,0,0,0,15.187,2.812ZM6.041,1.79a.211.211,0,0,1,.181-.1h3.3a.211.211,0,0,1,.181.1l.614,1.023H5.428Zm6.9,14.523H2.812V4.5H12.938ZM5.484,14.625h.844A.422.422,0,0,0,6.75,14.2V6.609a.422.422,0,0,0-.422-.422H5.484a.422.422,0,0,0-.422.422V14.2A.422.422,0,0,0,5.484,14.625Z",
    transform: "translate(0 0)",
    fill: "#bc0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedTrash);
export default __webpack_public_path__ + "static/media/redTrash.0669ce4b6042eff1621981bad1af233d.svg";
export { ForwardRef as ReactComponent };